import type { CampaignIntent } from "common/interfaces/KYDMarketing";

/**
 * Single source of truth for intent_type → performance category.
 * Used for ordering, variant (positive/negative/neutral), and performing_well/underperforming display.
 */
export function getIntentPerformanceCategory(
  intent: CampaignIntent
): "positive" | "negative" | "neutral" {
  if (!intent.actionable) return "neutral";
  switch (intent.intent_type) {
    case "INCREASE_BUDGET":
      return "positive";
    case "PAUSE_ADSET":
    case "PAUSE_AD":
    case "PAUSE_CAMPAIGN":
    case "CONSOLIDATE_ADSETS":
    case "INFORM_CREATIVE_FATIGUE":
      return "negative";
    default:
      return "neutral";
  }
}
